import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-select/dist/react-select.css';
import classes from './CoreLayout.scss';
import '../../styles/core.scss';

const mapActionCreators = {};

const mapStateToProps = state => ({
  activityOpen: state.activity.formOpen,
  companyOpen: state.company.formOpen,
  projectOpen: state.project.formOpen,
  staffOpen: state.staff.formOpen,
  personOpen: state.person.formOpen,
});

const CoreLayout = ({ children, router }) => (
  <div className={classes.coreLayout}>{children}</div>
);

CoreLayout.propTypes = {
  children: PropTypes.element.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapActionCreators)(CoreLayout);



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js